import styled from 'styled-components'

export const FormsWraperContainer = styled.div`
  padding:15px;
`